import React from "react";
import PropTypes from "prop-types";

const ValveGroupEditor = ({ config, onChange }) => {
  const handleSubChange = (valveKey, key, value) => {
    onChange({
      ...config,
      [valveKey]: {
        ...config[valveKey],
        [key]: value,
      },
    });
  };

  return (
    <div className="space-y-6">
      {["v1", "v2"].map((valve) => (
        <div
          key={valve}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-5"
        >
          <div className="flex items-center justify-between mb-4">
            <h4 className="text-base font-semibold text-gray-800">
              Valve {valve.toUpperCase()}
            </h4>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Trigger Message
              </label>
              <input
                type="text"
                value={config[valve]?.triggerMessage || ""}
                onChange={(e) =>
                  handleSubChange(valve, "triggerMessage", e.target.value)
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Fault Code
              </label>
              <input
                type="text"
                value={config[valve]?.faultCode || ""}
                onChange={(e) =>
                  handleSubChange(valve, "faultCode", e.target.value)
                }
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

ValveGroupEditor.propTypes = {
  field: PropTypes.string.isRequired,
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ValveGroupEditor;
